import type { SlaTaxExemptionFormModel } from './types';

export const DEFAULT_SLA_TAX_EXEMPTION: SlaTaxExemptionFormModel = {
  exempt: false,
  exemptaxCustomerId: '',
};

export function parseSlaTaxExemption(value?: string): SlaTaxExemptionFormModel {
  if (!value) return DEFAULT_SLA_TAX_EXEMPTION;
  try {
    const parsed = JSON.parse(value) as SlaTaxExemptionFormModel;
    return {
      exempt: parsed.exempt === true,
      exemptaxCustomerId: String(parsed.exemptaxCustomerId ?? ''),
    };
  } catch {
    return DEFAULT_SLA_TAX_EXEMPTION;
  }
}
